import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Wrapper,
  Copy,
  Bold,
  Row,
  Button,
  Icon,
  Spin,
  Scroll
} from "app/NativeComponents/common";

import { skipTrace } from "app/NativeActions";

class SelectFromNumber extends Component {
  constructor(props) {
    super(props);

    this.state = {
      temp_number: null,
      selected_from_number: props.selected_from_number,
      show_options: false
    };

    this._select_from_number = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selected_from_number !== this.props.selected_from_number) {
      this.setState({
        selected_from_number: this.props.selected_from_number
      });
    }

    if (
      prevState.selected_from_number !== this.props.selected_from_number &&
      this.props.onFromNumberChange
    ) {
      this.props.onFromNumberChange(this.props.selected_from_number);
    }
  }

  renderPhoneNumberText() {
    if (
      this.props.selected_from_number &&
      this.props.selected_from_number.phone_number_placeholder
    ) {
      return this.props.selected_from_number.phone_number_placeholder;
    }

    if (
      !this.props.team_phone_number_groups ||
      this.props.team_phone_number_groups.length == 0
    ) {
      return "No Numbers Available";
    }

    return "Select a Number";
  }

  renderOptions() {
    if (this.state.show_options) {
      return (
        <Scroll
          style={{
            maxHeight: 200
          }}
        >
          {this.props.team_phone_number_groups.map((phone_number, i) => {
            return (
              <Button
                key={i}
                style={{
                  height: 50,
                  alignItems: "center",
                  justifyContent: "center"
                }}
                onPress={() => {
                  this.props.updateSelectedFromPhoneNumber(phone_number);
                  this.setState({
                    show_options: false
                  });
                }}
              >
                <Row
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    paddingRight: 5,
                    paddingLeft: 5
                  }}
                >
                  <Icon
                    style={{
                      width: 30,
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                    icon={
                      phone_number.id == this.state.selected_from_number.id
                        ? "radio-button-checked"
                        : "radio-button-unchecked"
                    }
                  />

                  <Wrapper>
                    <Copy>
                      <Bold>{phone_number.phone_number_placeholder}</Bold>
                    </Copy>
                    <Copy style={{ fontSize: 10 }}>
                      {phone_number.phone_label}
                    </Copy>
                  </Wrapper>
                </Row>
              </Button>
            );
          })}
        </Scroll>
      );
    }

    return (
      <Button
        style={{ height: 50, alignItems: "center", justifyContent: "center" }}
        onPress={() => {
          if (
            this.props.team_phone_number_groups &&
            this.props.team_phone_number_groups.length > 0
          ) {
            this.setState({
              show_options: !this.state.show_options
            });
          } else {
            this.props.appRedirect({
              redirect: "goForward",
              payload: { add: "add-phone-number" }
            });
          }
        }}
      >
        <Row style={{ padding: 10 }}>
          <Copy style={{ marginRight: 10 }}>
            <Bold>{this.renderPhoneNumberText()}</Bold>
          </Copy>
          <Icon
            fa_icon="sort"
            size={14}
            color={this.props.colors.light_gray_color}
          />
        </Row>
      </Button>
    );
  }

  render() {
    if (this.props.team_phone_numbers_loading) {
      return (
        <Wrapper style={{ paddingLeft: 15, paddingRight: 15 }}>
          <Row style={{ marginBottom: 5, alignItems: "flex-start" }}>
            <Wrapper
              style={{
                width: 40,
                height: 50,
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Copy>From:</Copy>
            </Wrapper>
            <Wrapper>
              <Wrapper
                style={{
                  height: 50,
                  margin: 10,

                  marginBottom: 0,
                  marginTop: 0,
                  borderRadius: 5,
                  borderColor: this.props.colors.border_color,
                  borderWidth: 1,
                  borderStyle: "solid",
                  backgroundColor: this.props.colors.card_color,
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Row style={{ paddingLeft: 10, paddingRight: 10 }}>
                  <Spin size="small" />
                  <Copy style={{ marginLeft: 5 }}>Loading Numbers</Copy>
                </Row>
              </Wrapper>
            </Wrapper>
          </Row>
        </Wrapper>
      );
    }
    return (
      <Wrapper style={{ paddingLeft: 15, paddingRight: 15 }}>
        <Row style={{ marginBottom: 5 }}>
          <Copy style={{ width: 40 }}>From:</Copy>
          <Wrapper wrapper_ref={this._select_from_number}>
            <Wrapper
              style={{
                margin: 10,
                marginBottom: 0,
                marginTop: 0,
                borderRadius: 5,
                borderColor: this.props.colors.border_color,
                borderWidth: 1,
                borderStyle: "solid",
                backgroundColor: this.props.colors.card_color
              }}
            >
              {this.renderOptions()}
            </Wrapper>
          </Wrapper>
        </Row>
      </Wrapper>
    );
  }
}

export default SelectFromNumber;
